import {useFetchData} from 'hooks/api/useFetchData'
import {CustomEmployeeField} from 'types/api/settings/employeeFieldGroups/customEmployeeField'

// oxlint-disable-next-line typescript/no-explicit-any
export const useFetchCustomEmployeeFields = (clientId: string, params?: any) => {
  const path = `/api/clients/${clientId}/custom_employee_fields`
  return useFetchData<CustomEmployeeField[]>(path, [], {params: params})
}
